import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import RangeFacetOld from "./RangeFacet-old"
import Sort from "./Sort"
import Icon from "./elements/Icon"
import { useProductFilters } from "@nosto/preact"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            htmlFor={toggleButtonId}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_291_51680)">
                <path d="M0.290663 14.742C0.204315 14.8314 0.156536 14.9511 0.157616 15.0754C0.158696 15.1997 0.208549 15.3186 0.296437 15.4065C0.384325 15.4944 0.503216 15.5442 0.627503 15.5453C0.751791 15.5464 0.87153 15.4986 0.960932 15.4122L8.00777 8.3673L15.193 15.271C15.2608 15.3353 15.346 15.3783 15.4381 15.3944C15.5301 15.4106 15.6249 15.3992 15.7105 15.3618C15.7961 15.3243 15.8688 15.2625 15.9194 15.1839C15.97 15.1054 15.9963 15.0137 15.9951 14.9202C15.9939 14.8579 15.9806 14.7965 15.9557 14.7394C15.9308 14.6823 15.8949 14.6307 15.85 14.5874L8.67804 7.69609L15.7097 0.665365C15.7538 0.621355 15.7888 0.569094 15.8126 0.511568C15.8365 0.454042 15.8488 0.392376 15.8489 0.330092C15.8489 0.267807 15.8367 0.206124 15.8129 0.148564C15.7891 0.091004 15.7542 0.0386943 15.7102 -0.00537851C15.6662 -0.0494513 15.6139 -0.084424 15.5564 -0.1083C15.4989 -0.132176 15.4372 -0.144487 15.3749 -0.144531C15.3126 -0.144575 15.2509 -0.132351 15.1934 -0.108556C15.1358 -0.0847619 15.0835 -0.0498631 15.0394 -0.00585255L7.9945 7.03909L0.810193 0.137303C0.765941 0.0914599 0.712902 0.0550089 0.654244 0.0301281C0.595586 0.00524734 0.532514 -0.00755247 0.468798 -0.00750636C0.405082 -0.00746022 0.342028 0.00543089 0.283407 0.0303965C0.224785 0.0553622 0.171798 0.0918899 0.127613 0.137797C0.0834278 0.183704 0.0489509 0.238047 0.026243 0.29758C0.00353509 0.357112 -0.00693779 0.420612 -0.00454975 0.484284C-0.0021617 0.547955 0.0130383 0.610492 0.0401417 0.668156C0.0672452 0.725821 0.105696 0.777429 0.153196 0.819897L7.32328 7.71031L0.290663 14.742Z" fill="black"/>
            </g>
            <defs>
                <clipPath id="clip0_291_51680">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
            </svg>
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()
    const { filters, removeAll } = useProductFilters()

    useEffect(() => {
        const toggleCheckbox = document.getElementById(toggleButtonId)
        const body = document.body

        const handleToggleChange = () => {
            if (toggleCheckbox.checked) {
                body.classList.add("overflow-hidden")
            } else {
                body.classList.remove("overflow-hidden")
            }
        }

        toggleCheckbox?.addEventListener("change", handleToggleChange)

        return () => {
            toggleCheckbox.removeEventListener("change", handleToggleChange)
            body.classList.remove("overflow-hidden")
        }
    }, [])

    const closeSidebar = () => {
        const toggleCheckbox = document.getElementById(toggleButtonId)
        if (toggleCheckbox) {
            toggleCheckbox.checked = false
            toggleCheckbox.dispatchEvent(new Event("change"))
        }
    }

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} className="ns-facet-sidebar-toggle ns-d-none" />
            <label
                className="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                htmlFor={toggleButtonId}
            />
            <div
                className="ns-sidebar-wrapper ns-h-100"
            >
                <div className="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div className="ns-sidebar-header flex ns-align-items-center lg:hidden w-full justify-between pb-6">
                        <span className="color-text text-[20px] uppercase leading-[120%] font-gerstner">Filters</span>
                        <ToggleSidebarButton />
                    </div>
                    <div className="ns-sidebar-menu">
                        <ul className="ns-list-unstyled ns-p-0 ns-m-0">
                            <Sort />
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
                <div className="mobile-filter-buttons lg:hidden flex justify-between gap-2 fixed">
                    <button 
                        type="button" 
                        className="btn-outline-dark w-full"
                        onClick={() => {
                            removeAll()
           
                        }}
                    >
                        clear
                    </button>
                    <button 
                        type="button" 
                        className="btn-primary-dark w-full"
                        onClick={closeSidebar} 
                    >
                        apply
                    </button>
                </div>
            </div> 
        </>
    ) : (
        ""
    )
}